import React, { memo, useMemo } from 'react';
import { Switch, withRouter } from 'react-router-dom';
import { createRoutes } from './createRoutes';
export var SignalRouter = /*#__PURE__*/memo(function SignalRouter(_ref) {
  var activeAccount = _ref.activeAccount,
      config = _ref.config,
      location = _ref.location;
  var routeDefinitions = config.routeDefinitions,
      routeKeyGenerator = config.routeKeyGenerator;
  var routeKey = routeKeyGenerator(location);
  var routes = useMemo(function () {
    var childProps = {
      activeAccount: activeAccount
    };
    return createRoutes(routeDefinitions, childProps);
  }, [routeDefinitions, activeAccount]);
  return /*#__PURE__*/React.createElement(Switch, {
    location: location,
    key: routeKey
  }, routes);
});
export default withRouter(SignalRouter);